export const GATEWAY_USER_SETTINGS_STORAGE_KEY = 'vision:gateway-settings:v1'
